module.exports = __webpack_public_path__ + "img/game_main_pc_253_off.d0eb7246.png";